import React from "react";
import { Clock, Check } from "lucide-react";

export default function TimeSlotGrid({ slots, selectedTime, onSelectTime }) {
  if (!slots || slots.length === 0) {
    return (
      <div className="timeslot-empty">
        <Clock />
        <p>Bu tarih için uygun saat dilimi bulunmamaktadır.</p>
      </div>
    );
  }

  return (
    <div className="timeslot-container">
      <h4 className="timeslot-title">
        <Clock />
        Uygun Saat Dilimleri
      </h4>
      <div className="timeslot-grid">
        {slots.map((slot) => {
          const isSelected = selectedTime === slot.time;
          let className = "timeslot";
          if (isSelected) className += " selected";

          return (
            <button
              key={slot.time}
              disabled={!slot.available}
              onClick={() => onSelectTime(slot.time)}
              className={className}
            >
              {slot.time}
              {isSelected && <Check className="timeslot-check" />}
            </button>
          );
        })}
      </div>
    </div>
  );
}
